export default {
  order: {
    title: "Bestellung",
    pickupDate: "Abholdatum",
    pickup: "Abholort",
    dropoff: "Zielort", 
    passenger: "Passagier",
    comment: "Kommentar",
    vehicle: "Fahrzeug",
    chauffeur: "Fahrer",
    passengersCount: "Passagiere",
    childSeats: "Kindersitze",
    flightNumber: "Flugnummer",
    nameSign: "Namensschild",
    speaks: "Spricht",
    call: "Anrufen",
    licensePlate: "Kennzeichen",
    category: "Kategorie",
    status: {
      new: "Bestätigung ausstehend",
      confirmed: "Bestellung bestätigt",
      on_my_way: "Unterwegs",
      at_the_location: "Am Ort angekommen",
      pob: "Passagier an Bord",
      clear: "Bestellung abgeschlossen",
      no_show: "Passagier nicht erschienen",
      canceled: "Bestellung storniert"
    },
    statusDescriptions: {
      new: "Bestellung wartet auf Lieferantenbestätigung",
      confirmed: "Lieferant hat Bestellung bestätigt, wartet auf Start",
      on_my_way: "Fahrer auf dem Weg zum Abholort",
      at_the_location: "Fahrer angekommen und wartet auf Passagier",
      pob: "Passagier eingestiegen, auf dem Weg zum Zielort",
      clear: "Bestellung erfolgreich abgeschlossen",
      no_show: "Passagier ist nicht am Abholort erschienen",
      canceled: "Bestellung storniert"
    },
    messages: {
      noChauffeurAssigned: "Ihr Fahrer wurde noch nicht zugewiesen",
      detailsWillAppear: "Details werden hier nach Zuweisung angezeigt",
      unknown: "Unbekannt",
      started: "Gestartet",
      awaitingAssignment: "Warte auf Zuweisung"
    },
    childSeatsTypes: {
      child_01: "Babyschale (6 Monate)",
      child_02: "Kindersitz (0-7 Jahre)",
      child_03: "Sitzerhöhung (6-12 Jahre)"
    },
    distance: "{distance} km",
    review: "Bewerten Sie Ihre Reise",
    review_status: {
      perfect: 'Perfekt',
      good: 'Gut',
      average: 'Durchschnittlich',
      bad: 'Schlecht',
      terrible: 'Furchtbar'
    }
  },
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    loading: "Lädt...",
    error: "Fehler"
  }
}